<script setup>
import { RouterView } from 'vue-router'
import { useJwt } from '@vueuse/integrations/useJwt'

const params = new URLSearchParams(window.location.search)
const token = params.get('token')
if (token) {
  const { payload } = useJwt(token)
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem("userData", JSON.stringify(payload.value))
      localStorage.setItem("accessToken", token)
    }
  } catch (_) { /* no-op */ }
}
</script>
<template>
  <RouterView />
</template>

<style lang="scss">
@use "assets/sass/app";
</style>
